import { PipeTransform, Pipe } from '@angular/core';
import { environment } from '../../environments/environment';

@Pipe({name: 'assetsContext'})
export class AssetsContextPipe implements PipeTransform {
  transform(url: string): string {
    const delimiter = url.match(/\/$/g) ? '' : '/';
    return `${environment.assetsPath}${delimiter}${url}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/assets.pipes.ts